import React,{createContext,useCallback,useContext,useMemo,useRef,useState} from 'react';
import Modal from '../components/Modal';

const ConfirmContext=createContext(null);

/**
 * Shared confirmation dialog for Super Admin + Institute business actions.
 * Avoids blocking browser confirm() dialogs and keeps destructive workflows
 * consistent with the application modal design.
 */
export function ConfirmProvider({children}){
 const resolverRef=useRef(null);
 const [state,setState]=useState(null);
 const finish=useCallback((answer)=>{
  const resolve=resolverRef.current;
  resolverRef.current=null;
  setState(null);
  resolve?.(Boolean(answer));
 },[]);
 const requestConfirm=useCallback((messageOrOptions)=>new Promise((resolve)=>{
  if(resolverRef.current)resolverRef.current(false);
  const options=typeof messageOrOptions==='string'?{message:messageOrOptions}:messageOrOptions||{};
  resolverRef.current=resolve;
  setState({
   title:options.title||'Please Confirm',
   subtitle:options.subtitle||'Review this action before continuing.',
   message:options.message||'Do you want to continue?',
   confirmLabel:options.confirmLabel||'Confirm',
   cancelLabel:options.cancelLabel||'Cancel',
   tone:options.tone||'danger',
   icon:options.icon||'⚠️'
  });
 }),[]);
 const value=useMemo(()=>({requestConfirm}),[requestConfirm]);
 return <ConfirmContext.Provider value={value}>
  {children}
  <Modal open={Boolean(state)} onClose={()=>finish(false)} closeOnBackdrop title={state?.title} subtitle={state?.subtitle} size="md" icon={state?.icon||'⚠️'}>
   {state&&<div className="confirm-dialog-content">
    <p className="confirm-dialog-message">{state.message}</p>
    <div className="form-actions modal-sticky-actions">
     <button type="button" className="button button-secondary" onClick={()=>finish(false)}>{state.cancelLabel}</button>
     <button type="button" className={state.tone==='danger'?'button button-danger':'button button-primary'} onClick={()=>finish(true)} autoFocus>{state.confirmLabel}</button>
    </div>
   </div>}
  </Modal>
 </ConfirmContext.Provider>;
}

export function useConfirm(){
 return useContext(ConfirmContext)||{requestConfirm:async()=>false};
}
